var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BLOCK_TIME_SECONDS } from "../utils";
export class DefaultSystemAPI {
    constructor(api) {
        this.api = api;
    }
    getCurrentBlockNumber() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.api.query.system.number()).toNumber();
        });
    }
    getCurrentActiveBlockNumber(atBlock) {
        return __awaiter(this, void 0, void 0, function* () {
            const blockHash = atBlock || (yield this.api.rpc.chain.getFinalizedHead());
            const api = yield this.api.at(blockHash);
            return (yield api.query.security.activeBlockCount()).toNumber();
        });
    }
    subscribeToFinalizedBlockHeads(callback) {
        return __awaiter(this, void 0, void 0, function* () {
            const unsub = yield this.api.rpc.chain.subscribeFinalizedHeads((head) => {
                callback(head);
            });
            return unsub;
        });
    }
    subscribeToCurrentBlockHeads(callback) {
        return __awaiter(this, void 0, void 0, function* () {
            const unsub = yield this.api.rpc.chain.subscribeAllHeads((head) => {
                callback(head);
            });
            return unsub;
        });
    }
    setCode(code) {
        const tx = this.api.tx.sudo.sudoUncheckedWeight(this.api.tx.system.setCode(code), "0");
        return { extrinsic: tx, event: this.api.events.system.CodeUpdated };
    }
    getBlockHash(blockNumber) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.api.query.system.blockHash(blockNumber);
        });
    }
    getFutureBlockNumber(secondsFromNow) {
        return __awaiter(this, void 0, void 0, function* () {
            const currentBlock = yield this.getCurrentBlockNumber();
            const differenceInBlocks = Math.round(secondsFromNow / BLOCK_TIME_SECONDS);
            return currentBlock + differenceInBlocks;
        });
    }
}
//# sourceMappingURL=system.js.map